import Vue from 'vue'
import Vuex from 'vuex'
import VueCookie from 'vue-cookie'
import createPersistedState from 'vuex-persistedstate'

import actions from './actions'
import mutations from './mutations'
import state from './state'

Vue.use(Vuex)
Vue.use(VueCookie)

export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  actions,
  mutations,
  state,
  getters: {
    isLoggedIn: state => {
      return state.token
    },
    getUser: state => {
      return state.user
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js